export default "__VITE_ASSET__D$FWZ66Q__"